var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#0B69C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M492.497 354.189C474.184 398.271 443.911 436.354 405.097 464.139C366.283 491.924 320.474 508.303 272.842 511.427L145.415 384L175.495 223.865L136.758 185.263L185.869 135.848L286.046 236.025L292.076 229.996L362.577 224.303L492.497 354.189Z",
    fill: "url(#paint0_linear_6_60)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.737 162.931C198.743 169.849 196.698 176.613 192.858 182.368C189.019 188.123 183.559 192.61 177.168 195.26C170.778 197.911 163.745 198.606 156.96 197.258C150.174 195.91 143.941 192.58 139.049 187.688C134.157 182.796 130.827 176.563 129.479 169.777C128.131 162.992 128.826 155.959 131.476 149.568C134.127 143.178 138.614 137.718 144.369 133.879C150.124 130.039 156.888 127.993 163.806 128C173.068 128.009 181.947 131.692 188.496 138.241C195.045 144.79 198.728 153.669 198.737 162.931Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.198 212.446H145.415C140.634 212.446 136.758 216.322 136.758 221.103V375.343C136.758 380.124 140.634 384 145.415 384H182.198C186.979 384 190.855 380.124 190.855 375.343V221.103C190.855 216.322 186.979 212.446 182.198 212.446Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M383.158 301.373V376.05C383.158 378.159 382.32 380.181 380.83 381.672C379.339 383.162 377.317 384 375.208 384H335.731C333.622 384 331.6 383.162 330.109 381.672C328.619 380.181 327.781 378.159 327.781 376.05V303.697C327.781 292.884 330.914 256.539 299.554 256.539C275.234 256.539 270.282 281.533 269.238 292.749V376.219C269.194 378.286 268.347 380.255 266.875 381.708C265.403 383.161 263.424 383.983 261.356 384H223.158C222.113 384.004 221.077 383.802 220.111 383.404C219.144 383.006 218.266 382.421 217.527 381.682C216.788 380.942 216.202 380.064 215.804 379.098C215.407 378.131 215.204 377.096 215.208 376.05V220.429C215.204 219.383 215.406 218.345 215.804 217.377C216.201 216.409 216.786 215.528 217.525 214.786C218.263 214.045 219.141 213.456 220.108 213.055C221.075 212.653 222.111 212.446 223.158 212.446H261.356C262.415 212.428 263.468 212.622 264.452 213.015C265.436 213.408 266.332 213.993 267.088 214.736C267.844 215.479 268.444 216.365 268.853 217.343C269.263 218.32 269.474 219.37 269.474 220.429V233.903C278.501 220.429 291.907 209.92 320.438 209.92C383.528 209.886 383.158 268.935 383.158 301.373Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_60",
    x1: 175.596,
    y1: 237.036,
    x2: 412.362,
    y2: 455.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#084A8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#084A8C",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#084A8C",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#084A8C",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/linked.17f9c4b59c984ab01f616d5f6df4da03.svg";
export { ForwardRef as ReactComponent };